import { footer, actions } from '../data/content';

/**
 * Resolves a call to action to a real destination.
 *
 * Each action can be given a URL in `actions` (a donation processor, a
 * volunteer form). Until one is, it falls back to an addressed email — which
 * is a working destination for a small ministry, and far better than an
 * anchor that drops the visitor at the footer with no idea what to do next.
 */
export default function actionHref(key) {
  const configured = actions[key];
  if (configured?.url) return configured.url;

  const subject = encodeURIComponent(configured?.subject || 'TEEEM');
  return `mailto:${footer.contact.email}?subject=${subject}`;
}
